import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initPinMenus = () => {
	const module = document.querySelector('.menus')

	if (!module || window.innerWidth < 1024) return

	const menus = module.querySelectorAll('.menus__pin')

	menus.forEach(menu => {
		const inner = menu.querySelector('.menus__menu')

		gsap.timeline({
			scrollTrigger: {
				pin: menu,
				trigger: menu,
				anticipatePin: 1,
				endTrigger: module,
				start: `center center`,
				end: 'bottom bottom',
				scrub: 0.9
			}
		})

		gsap.from(inner, {
			scrollTrigger: {
				trigger: inner,
				start: `top bottom`,
				end: 'center center',
				scrub: 0.9
			},
			rotate: 0,
			scale: 0.95,
			ease: 'power1.inOut'
		})
	
	})
}

export default () => {}